import { Children, type PropsWithChildren, type ReactNode } from "react";
import { useTranslations } from "@/features/translations/components/translations.tsx";

type ListProps = PropsWithChildren<{ fallback?: ReactNode }>;
export function List({ children, fallback }: ListProps) {
    const t = useTranslations();

    if (Children.count(children) === 0) return fallback ?? <p>{t("no_items")}</p>;

    return children;
}
